shadow$provide[342] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, RenderTarget:{enumerable:true, get:function() {
  return RenderTarget;
}}});
var require$three = require("three");
class RenderTarget {
  constructor(gl, width, height, frames, options) {
    this.gl = gl;
    if (options == null) {
      options = {};
    }
    if (options.minFilter == null) {
      options.minFilter = require$three.NearestFilter;
    }
    if (options.magFilter == null) {
      options.magFilter = require$three.NearestFilter;
    }
    if (options.format == null) {
      options.format = require$three.RGBAFormat;
    }
    if (options.type == null) {
      options.type = require$three.UnsignedByteType;
    }
    this.options = options;
    this.width = width || 1;
    this.height = height || 1;
    this.frames = frames || 1;
    this.buffers = this.frames + 1;
    this.build();
  }
  build() {
    let i;
    const make = () => new require$three.WebGLRenderTarget(this.width, this.height, this.options);
    this.targets = (() => {
      let asc, end;
      const result = [];
      for (i = 0, end = this.buffers, asc = 0 <= end; asc ? i < end : i > end; asc ? i++ : i--) {
        result.push(make());
      }
      return result;
    })();
    const acc = [];
    this.targets.forEach(target => acc.push(target.texture));
    this.reads = acc;
    this.write = this.targets[this.buffers - 1];
    this.uniforms = {dataResolution:{type:"v2", value:new require$three.Vector2(1 / this.width, 1 / this.height),}, dataTexture:{type:"t", value:this.reads[0],}, dataTextures:{type:"tv", value:this.reads,},};
  }
  cycle() {
    this.targets.unshift(this.targets.pop());
    this.write = this.targets[this.buffers - 1];
    this.reads.unshift(this.reads.pop());
    this.uniforms.dataTexture.value = this.reads[0];
  }
  warmup(callback) {
    return (() => {
      const result = [];
      for (let i = 0, end = this.buffers, asc = 0 <= end; asc ? i < end : i > end; asc ? i++ : i--) {
        callback(this.write);
        result.push(this.cycle());
      }
      return result;
    })();
  }
  dispose() {
    for (const target of Array.from(this.targets)) {
      target.dispose();
    }
    return this.targets = this.reads = this.write = null;
  }
}

};